/**
 * Removes quarter-related tokens from a format string.
 */
export function removeQuarterFromFormat(format: string) {
  return format.replace(/(Qo|qo|Q|q)+/g, '');
}
